/**
 * Banner de la landing: campaña «primeros 100 de la app» (5 días gratis).
 * Lee el contador público y solo se pinta si la campaña está abierta; si el
 * API falla o los cupos se acabaron, no ocupa espacio.
 */
'use client';

import { useEffect, useState } from 'react';
import { campaignBannerCopy } from '@/lib/billing/trial-campaign-copy';

export default function AppCampaignBanner() {
  const [copy, setCopy] = useState(null);

  useEffect(() => {
    let vivo = true;
    fetch('/api/campaigns/app-100')
      .then((r) => (r.ok ? r.json() : null))
      .then((s) => { if (vivo) setCopy(campaignBannerCopy(s)); })
      .catch(() => {});
    return () => { vivo = false; };
  }, []);

  if (!copy) return null;
  return (
    <a href="/app" className="appCampaignBanner" data-track="hero-campana-100">
      <span className="appCampaignTitle">{copy.title}</span>
      <span className="appCampaignCounter">{copy.counter}</span>
      <span className="appCampaignCta">{copy.cta} →</span>
    </a>
  );
}
